import { render, staticRenderFns } from "./cutimg.vue?vue&type=template&id=5c2aad2e&scoped=true"
import script from "./cutimg.vue?vue&type=script&lang=js"
export * from "./cutimg.vue?vue&type=script&lang=js"
import style0 from "./cutimg.vue?vue&type=style&index=0&id=5c2aad2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2aad2e",
  null
  
)

export default component.exports